import React from "react";



export function InviteUserContainer({ accessToken, name, email }) {
  return(
      <p>InviteUser</p>
  )
}
 